import { Toaster as Sonner, type ToasterProps } from "sonner";

export const Toaster = ({ ...props }: ToasterProps) => (
  <Sonner
    className="toaster group"
    style={
      {
        "--normal-bg": "var(--popover)",
        "--normal-text": "var(--popover-foreground)",
        "--normal-border": "var(--border)",
      } as React.CSSProperties
    }
    theme="light"
    toastOptions={{
      classNames: {
        title: "group-[.toaster]:first-letter:uppercase",
      },
    }}
    {...props}
  />
);
